"use client";

import { Button } from "@/components/button/button";

interface ErrorLayoutProps {
  error: Error;
  reset?: () => void;
}

export default function ErrorLayout(props: ErrorLayoutProps) {
  const isChunkLoadError = /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module/i.test(
    `${props.error?.name ?? ""} ${props.error?.message ?? ""}`
  );

  return (
    <div className="flex flex-col items-center gap-6 px-4 py-8">
      <h1 className="font-medium">Something went wrong!</h1>
      <div className="max-w-xl rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950">
        <p className="font-semibold">Using Google Translate?</p>
        <p className="mt-1">
          Disable the Google Translate extension on this page, then reload. It can break the app UI and cause this error.
        </p>
        {isChunkLoadError ? (
          <p className="mt-3 border-t border-amber-300 pt-3">
            This tab may have an outdated app chunk. Reload once to fetch the latest version.
          </p>
        ) : null}
      </div>
      <Button variant="destructive" onClick={() => (isChunkLoadError ? window.location.reload() : props.reset?.())}>
        Try again
      </Button>
    </div>
  );
}
